module.exports = __webpack_public_path__ + "img/game05.3d82be7b.png";